import type { State } from '../../state/types.tsx';

export const getConfluenceMacroType = (state: State) =>
	state.ui.ConfluenceMacro.confluenceMacroType;
